import React, { useEffect } from 'react';
import { Hero } from '../components/Hero';
import { Welcome } from '../components/Welcome';
import { MarketContext } from '../components/MarketContext';
import { LaunchCTA } from '../components/LaunchCTA';
import { Vision } from '../components/Vision';
import { JoinQuestionnaire } from '../components/JoinQuestionnaire';
import { DomainCTA } from '../components/DomainCTA';
import { Footer } from '../components/Footer';
import { setPageMeta } from '../lib/setPageMeta';
export function Home() {
  useEffect(() => {
    setPageMeta({
      description: 'A bold new platform for adult dance creators and their fans. Concept in progress.'
    });
  }, []);
  return <div className="min-h-screen bg-zinc-950 text-zinc-100 font-sans selection:bg-magenta-500/30 selection:text-magenta-100" data-id="element-357">
      <main data-id="element-358">
        <Hero data-id="element-359" />
        <Welcome data-id="element-360" />
        <MarketContext data-id="element-361" />
        <LaunchCTA data-id="element-362" />
        <Vision data-id="element-363" />
        <JoinQuestionnaire data-id="element-364" />
        <DomainCTA data-id="element-365" />
      </main>
      <Footer data-id="element-366" />
    </div>;
}